export const industryOptions = [
  { label: 'Construction', value: 'Construction' },
  { label: 'Customer Services', value: 'Customer Services' },
  { label: 'Energy', value: 'Energy' },
  { label: 'Engineering', value: 'Engineering' },
  { label: 'Finance', value: 'Finance' },
  { label: 'Healthcare', value: 'Healthcare' },
  { label: 'Hospitality', value: 'Hospitality' },
  { label: 'HR', value: 'HR' },
  { label: 'IT', value: 'IT' },
  { label: 'Legal', value: 'Legal' },
  { label: 'Logistics', value: 'Logistics' },
  { label: 'Media', value: 'Media' },
  { label: 'Military', value: 'Military' },
  { label: 'Office and Admin', value: 'Office and Admin' },
  { label: 'Retail', value: 'Retail' },
  { label: 'Sales and Marketing', value: 'Sales and Marketing' },
  { label: 'Science', value: 'Science' },
  { label: 'Catering', value: 'Catering' },
  { label: 'Electronics', value: 'Electronics' },
  { label: 'HR and Training', value: 'HR and Training' },
  { label: 'Rec2Rec', value: 'Rec2Rec' },
  { label: 'Tourism', value: 'Tourism' },
  { label: 'Leisure', value: 'Leisure' },
];

export const employmentTypeOptions = [
  { label: 'Any', value: 'Any' },
  { label: 'Permanent', value: 'Permanent' },
  { label: 'Permanent Only', value: 'Permanent Only' },
  { label: 'Contract', value: 'Contract' },
  { label: 'Contract Only', value: 'Contract Only' },
];

export const visaStatusOptions = {
  UKEur: [
    { label: 'UK/EU Citizen', value: 'UK/EU Citizen' },
    { label: 'GB Sponsorship Required', value: 'GB Sponsorship Required' },
    { label: 'Permit Holder', value: 'Permit Holder' },
  ],
  Americas: [
    { label: 'US Citizen', value: 'US Citizen' },
    { label: 'H1B Visa Holder', value: 'H1B Visa Holder' },
    { label: 'F1 Visa Holder', value: 'F1 Visa Holder' },
    { label: 'USA Sponsorship Required', value: 'USA Sponsorship Required' },
    { label: 'Green Card Holder', value: 'Green Card Holder' },
    { label: 'TN Visa Holder EAD', value: 'TN Visa Holder EAD' },
  ],
  Canada: [
    { label: 'Canadian Citizen', value: 'Canadian Citizen' },
    { label: 'CAN Sponsorship Required', value: 'CAN Sponsorship Required' },
  ],
  AusAsia: [
    { label: 'Aus/NZ Citizen', value: 'Aus/NZ Citizen' },
    { label: 'Working Visa', value: 'Working Visa' },
    { label: 'Permanent Resident', value: 'Permanent Resident' },
    { label: 'AUS Sponsorship Required', value: 'AUS Sponsorship Required' },
  ],
};

export const salaryOptions = {
  UKEur: [
    { label: 'Any', value: 'Any' },
    { label: '£15,000', value: '£15,000' },
    { label: '£15,000 - £20,000', value: '£15,000 - £20,000' },
    { label: '£20,000 - £25,000', value: '£20,000 - £25,000' },
    { label: '£25,000 - £30,000', value: '£25,000 - £30,000' },
    { label: '£30,000 - £40,000', value: '£30,000 - £40,000' },
    { label: '£40,000 - £50,000', value: '£40,000 - £50,000' },
    { label: '£50,000 - £75,000', value: '£50,000 - £75,000' },
    { label: '£75,000 - £100,000', value: '£75,000 - £100,000' },
    { label: '£100,000 +', value: '£100,000 +' },
  ],
  Americas: [
    { label: 'Any', value: 'Any' },
    { label: '$22,000', value: '$22,000' },
    { label: '$22,000 - $30,000', value: '$22,000 - $30,000' },
    { label: '$30,000 - $37,000', value: '$30,000 - $37,000' },
    { label: '$37,000 - $45,000', value: '$37,000 - $45,000' },
    { label: '$45,000 - $60,000', value: '$45,000 - $60,000' },
    { label: '$60,000 - $75,000', value: '$60,000 - $75,000' },
    { label: '$75,000 - $112,000', value: '$75,000 - $112,000' },
    { label: '$112,000 - $150,000', value: '$112,000 - $150,000' },
    { label: '$150,000 +', value: '$150,000 +' },
  ],
  Canada: [
    { label: 'Any', value: 'Any' },
    { label: '$22,000', value: '$22,000' },
    { label: '$22,000 - $30,000', value: '$22,000 - $30,000' },
    { label: '$30,000 - $37,000', value: '$30,000 - $37,000' },
    { label: '$37,000 - $45,000', value: '$37,000 - $45,000' },
    { label: '$45,000 - $60,000', value: '$45,000 - $60,000' },
    { label: '$60,000 - $75,000', value: '$60,000 - $75,000' },
    { label: '$75,000 - $112,000', value: '$75,000 - $112,000' },
    { label: '$112,000 - $150,000', value: '$112,000 - $150,000' },
    { label: '$150,000 +', value: '$150,000 +' },
  ],
  AusAsia: [
    { label: 'Any', value: 'Any' },
    { label: '$30,000', value: '$30,000' },
    { label: '$30,000 - $40,000', value: '$30,000 - $40,000' },
    { label: '$30,000 - $40,000', value: '$30,000 - $40,000' },
    { label: '$40,000 - $50,000', value: '$40,000 - $50,000' },
    { label: '$50,000 - $60,000', value: '$50,000 - $60,000' },
    { label: '$60,000 - $80,000', value: '$60,000 - $80,000' },
    { label: '$80,000 - $100,000', value: '$80,000 - $100,000' },
    { label: '$100,000 - $125,000', value: '$100,000 - $125,000' },
    { label: '$125,000 - $150,000', value: '$125,000 - $150,000' },
    { label: '$150,000 +', value: '$150,000 +' },
  ],
};

export const minEducationOptions = {
  UKEur: [
    { label: 'Any', value: 'Any' },
    { label: 'GCSE / O-Level', value: 'GCSE / O-Level' },
    { label: 'A Level, OND, GNVQ', value: 'A Level, OND, GNVQ' },
    { label: 'HND', value: 'HND' },
    { label: 'Bachelors Degree', value: 'Bachelors Degree' },
    { label: 'Masters Degree', value: 'Masters Degree' },
    { label: 'Doctorate, PhD', value: 'Doctorate, PhD' },
  ],
  Americas: [
    { label: 'Any', value: 'Any' },
    { label: 'High School Diploma', value: 'High School Diploma' },
    { label: 'Degree', value: 'Degree' },
    { label: 'Diploma', value: 'Diploma' },
    { label: 'Bachelors Degree', value: 'Bachelors Degree' },
    { label: 'Masters Degree', value: 'Masters Degree' },
    { label: 'Doctorate, PhD', value: 'Doctorate, PhD' },
  ],
  Canada: [
    { label: 'Any', value: 'Any' },
    { label: 'Secondary Education', value: 'Secondary Education' },
    { label: 'College Education', value: 'College Education' },
    { label: 'Diploma Education', value: 'Diploma Education' },
    { label: 'Bachelors Degree', value: 'Bachelors Degree' },
    { label: 'Masters Degree', value: 'Masters Degree' },
    { label: 'Doctorate, PhD', value: 'Doctorate, PhD' },
  ],
  AusAsia: [
    { label: 'Any', value: 'Any' },
    { label: 'Secondary School Certificate', value: 'Secondary School Certificate' },
    { label: 'HSC', value: 'HSC' },
    { label: 'Diploma Education', value: 'Diploma Education' },
    { label: 'Bachelors Degree', value: 'Bachelors Degree' },
    { label: 'Masters Degree', value: 'Masters Degree' },
    { label: 'Doctorate, PhD', value: 'Doctorate, PhD' },
  ],
};

export const skillMatchOptions = [
  { label: 'Any', value: 'Any' },
  { label: 'All', value: 'All' },
];
export const skillLevelOptions = [
  { label: 'Min', value: 'Min' },
  { label: 'Max', value: 'Max' },
];
export const experienceOptions = [
  { label: 'Any', value: 'Any' },
  { label: '0 - 1 Years', value: '0 - 1 Years' },
  { label: '1 - 3 Years', value: '1 - 3 Years' },
  { label: '3 - 5 Years', value: '3 - 5 Years' },
  { label: '5+ Years', value: '5+ Years' },
  { label: 'Basic', value: 'Basic' },
  { label: 'Intermediate', value: 'Intermediate' },
  { label: 'Advanced', value: 'Advanced' },
];

export const securityClearanceCheckBoxOptions = {
  'GB Can Take Clearance': 'GB Can Take Clearance',
  'Security Check': 'Security Check',
  'Counter Terrorism Check': 'Counter Terrorism Check',
  'Developed Vetting': 'Developed Vetting',
};
